// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakpoint":"767","tabletBreakpoint":"1024","dataRow":"styles_dataRow__1KUJf","item":"styles_item__1Uqoz"};